import React, {Component} from 'react';
import {AutoComplete, Select, Button, Input, Icon, Table, message, Popconfirm, Modal} from 'antd';
import {Redirect} from 'react-router';
import './style.less';
import Detail from './facilitydetail';
import api2 from '../../../api/api2';
import aes from '../../../api/aes/public';
import utils from '../../../utils/common';

const Option = Select.Option;
class FacilityList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isactive: 0,
      bindStatus: '',
      activationCodeType: '',
      isvisible: false,
      menuData: [
        {id: 2, name: '硬件'},
        {id: 1, name: '软件'},
        {id: 3, name: '流量产品'}
      ],
      statusData: ['全部', '已绑定', '未绑定', '锁定中'],

      activationCodeTypeData: [
        { label: '全部', value: '' },
        { label: '通用型', value: '0' },
      ],

      redirect: false,
      goodsName: '',
      agentNo: '',
      deviceSn: '',
      merchantCode: '',
      facilityData: [],
      search: {
        goods_property: 2, // 2 硬件 1 软件 3 流量产品
        pageSize: 10,
        total: 0,
        current: 1,
        current_page: 1, // 用于API请求
        onChange: this.changePage
      },
      form: {}
    };
  }
  componentWillMount() {
    this.loadList();
  }
  loadList() {
    const {
      goodsName, agentNo, deviceSn, merchantCode, bindStatus, search,
      activationCodeType
    } = this.state;
    let params = {
      goods_name: goodsName,
      agent_no: agentNo,
      device_sn: deviceSn,
      bind_merchant_code: merchantCode,
      bind_status: bindStatus,
      activation_code_type: activationCodeType,
      page_size: search.pageSize || search.page_size || 10,
      goods_property: search.goods_property,
      current_page: search.current_page || search.current || 1
    };
    params = utils.dealElement(params);
    window.api('eps.getordergoodsmanager', params).then(rs => {
      const currentPage = search.current_page || search.current || 1;
      const s = Object.assign({}, search, {
        total: rs.total_result || 0,
        current: currentPage,
        current_page: currentPage
      });
      this.setState({facilityData: rs.order_goods_manager_list, search: s});
    }).catch((error) => {
      error.service_error_code === 'EPS000000801' ? this.setState({redirect: true}) : null;
      message.error(error.service_error_message);
      this.setState({isLoading: false});
    });
  }
  // 按条件改变页面
  changePage = (page, pageSize) => {
    page = page === 0 ? 1 : page;
    const search = Object.assign({}, this.state.search, {
      current: page,
      current_page: page,
      pageSize: pageSize || this.state.search.pageSize
    });
    this.setState({search}, () => {
      this.loadList();
    });
  }
  getState(status) {
    switch (status) {
      case '1':
        return (<span className="status-badge status-success">已绑定</span>);
      case '2':
        return (<span className="status-badge status-warning">未绑定</span>);
      case '3':
        return (<span className="status-badge status-locked">锁定中</span>);
      default:
        return (<span className="status-badge status-warning">未绑定</span>);
    }
  }
  getActivate(state) {
    switch (state) {
      case '1':
        return (<span className="status-badge status-inactive">未激活</span>);
      case '2':
        return (<span className="status-badge status-processing">激活中</span>);
      case '3':
        return (<span className="status-badge status-success">激活成功</span>);
      default:
        return (<span className="status-badge status-inactive">未激活</span>);
    }
  }
  selTap = async (id, index) => {
    let activationCodeTypeData;
    // 切换时，激活码类型默认值始终为"全部"（空字符串）
    const activationCodeTypeDefault = '';
    switch (index) {
      case 0:
        activationCodeTypeData = [
          { label: '全部', value: '' },
          { label: '通用型', value: '0' }
        ];
        break;
      case 1:
        activationCodeTypeData = [
          { label: '全部', value: '' },
          { label: '通用型', value: '0' },
          { label: '联拓通道专属', value: '1' }
        ];
        break;
      default:
        activationCodeTypeData = [];
    }
    const params = Object.assign({}, this.state.search, {
      goods_property: id,
      current: 1,
      current_page: 1,
      total: 0
    });
    console.log(params);
    await this.setState({
      isactive: index,
      search: params,
      activationCodeType: activationCodeTypeDefault,
      activationCodeTypeData: activationCodeTypeData,
      facilityData: [],
    }, () => {
      this.loadList();
    });
  }
  bindValue = (type, e) => {
    if (type === 'bindStatus' || type === 'activationCodeType') {
      this.setState({[type]: e});
    } else {
      this.setState({[type]: e.target.value});
    }
  }
  searchEvent = () => {
    this.loadList();
  }
  // 重置搜索条件
  resetFilter = () => {
    const search = Object.assign({}, this.state.search, {
      current: 1,
      current_page: 1
    });
    this.setState({
      goodsName: '',
      agentNo: '',
      deviceSn: '',
      merchantCode: '',
      bindStatus: '',
      activationCodeType: '',
      search
    }, () => {
      this.loadList();
    });
  }
  detailEvent = (item) => {
    window.api('eps.getordergoodsmanager', {id: item.id}).then(rs => {
      this.setState({
        form: rs.order_goods_manager_list[0],
        isvisible: true
      });
    });
  }
  cancel = () => {
    this.setState({
      isvisible: false
    });
  }
  getPartnerIdKey(item) {
    const promise = new Promise((resolve, reject) => {
      const getNo = window.common.getRequestNo(16);
      window.localStorage.setItem('platform_no', item.platform_no);
      window.localStorage.setItem('merchant_code', item.bind_core_merchant_code);
      window.localStorage.setItem('request_no', getNo);
      const params = {
        out_request_no: getNo, //随机生成
        core_merchant_no: item.bind_core_merchant_code //核心商户编号
      };
      api2.baseInstance('merchant.pidkeyquery', params).then(rs => {
        //const key = aes.Decrypt(window.localStorage.getItem('PKEY'));
        //window.localStorage.setItem('partnerID', aes.Decrypt(rs.partner_id_key, key));
        resolve(rs);
      }).catch(error => {
        message.error(error.message);
        reject(error);
      });
    });
    return promise;
  }
  decodingEvent = (item) => {
    const tradeNo = window.common.getRequestNo(10);
    const params = {
      out_trade_no: `EPSUNBIND${tradeNo}`, //商户请求单号(自动生成)
      merchant_no: item.bind_merchant_code, //门店编号
      identify_type: 'SN', //device_sn
      goods_id: item.goods_id, //商品goods_id
      device_sn: item.device_sn, //sn码
      operator_id: JSON.parse(window.localStorage.getItem('headParams')).login_name, //操作员登录人userName
      notify_url: (window.common.getUrl())[0] //
    };
    this.getPartnerIdKey(item).then(rs => {
      const key = aes.Decrypt(window.localStorage.getItem('PKEY'));
      window.localStorage.setItem('partnerID', aes.Decrypt(rs.partner_id_key, key));
      window.api('device.unbind', params).then(res => {
        message.success('解绑成功');
        this.loadList();
      }).catch(error => {
        message.error(error.message);
      });
    });
  }
  render() {
    // 激活有效期 0 硬件 1 软件 2 流量产品
    const activateDate = this.state.isactive === 1 ? {} : {
      title: '激活有效期',
      key: 'valid_date',
      dataIndex: 'valid_date'
    };
    // 激活码类型 0 硬件 1 软件 2 流量产品
    const activationCodeType = this.state.isactive === 2 ? {} :{
      title: '激活码类型',
      key: 'activation_code_type',
      dataIndex: 'activation_code_type',
      render: (codeType) => (
        codeType !== '' && codeType !== null ?
          (codeType === 0 ? '通用型' : codeType === 1 ? '联拓通道专属' : '')
          : ''
      ),
    };
    const columns = [
      {
        title: '商品名称',
        key: 'goods_name',
        dataIndex: 'goods_name'
      },
      {
        title: '代理商编号/代理商名称',
        key: 'agent_name',
        dataIndex: '',
        render: (record) => (
          <span>{record.agent_no}/{record.agent_name}</span>
        )
      },
      {
        title: 'sn码',
        key: 'device_sn',
        dataIndex: 'device_sn'
      },
      activationCodeType,
      activateDate,
      {
        title: '绑定状态',
        key: 'bind_status',
        dataIndex: 'bind_status',
        render: (status) => (
          this.getState(status)
        ),
      },
      {
        title: (<div style={{width: '180px'}}><p>门店编号/门店名称</p><p>商户编号/商户名称</p></div>),
        key: 'bind_core_merchant_code',
        dataIndex: '',
        render: (record) => (
          <div>
            <p className={!record.bind_merchant_code ? 'hide' : null}>{record.bind_merchant_code}/{record.bind_merchant_name}</p>
            <p className={!record.bind_core_merchant_code ? 'hide' : null}>{record.bind_core_merchant_code}/{record.bind_core_merchant_name}</p>
          </div>
        )
      },
      {
        title: '激活状态',
        key: 'activate_status',
        dataIndex: 'activate_status',
        render: (record) => (
          this.getActivate(record)
        )
      },
      {
        title: '操作',
        dataIndex: '',
        key: 'operation',
        render: (record) => (
          <div className="opearte-blocks">
            <span className="ml10" onClick={() => this.detailEvent(record)}>详情</span>
            <div className={record.bind_status === '2' ? 'hide' : 'inline'}>
              <Popconfirm
                title="是否需要解绑"
                onConfirm={() => this.decodingEvent(record)}
                okText="是"
                cancelText="否"
              >
                <span className="ml10" hidden={record.goods_property === '1'}>解绑</span>
              </Popconfirm>
            </div>
          </div>
        )
      }
    ];
    const {redirect} = this.state;
    if (redirect) return (<Redirect to="/login" />);
    return (
      <div className="facility-blocks">
        {/* 设备详情弹窗 */}
        <Modal
          title="设备详情"
          visible={this.state.isvisible}
          onCancel={this.cancel}
          width="700px"
          footer={
            <Button onClick={this.cancel}>关闭</Button>
          }
        >
          <Detail form={this.state.form} />
        </Modal>

        {/* 表格上方导航栏 */}
        <div className="nav-items">
          <div className="tap-items">
            {
              this.state.menuData.map((item, index) => <span key={index} onClick={() => this.selTap(item.id, index)} className={this.state.isactive === index ? 'active' : ''}>{item.name}</span>)
            }
          </div>
        </div>
        <ul className="search-blocks">
          <li className="items"><label className="label-text">商品名称:</label>
            <Input value={this.state.goodsName} onChange={this.bindValue.bind(this, 'goodsName')} placeholder="请输入商品名称" />
          </li>
          <li className="items">
            <label className="label-text">代理商编号:</label>
            <Input value={this.state.agentNo} onChange={this.bindValue.bind(this, 'agentNo')} placeholder="请输入代理商编号" />
          </li>
          <li className="items">
            <label className="label-text">sn码:</label>
            <Input value={this.state.deviceSn} onChange={this.bindValue.bind(this, 'deviceSn')} placeholder="请输入sn码" />
          </li>
          <li className="items">
            <label className="label-text">绑定状态:</label>
            <Select placeholder="请选择绑定状态" value={this.state.bindStatus} onChange={this.bindValue.bind(this, 'bindStatus')} style={{width: '210px'}}>
              {
                this.state.statusData.map((item, index) => (
                  <Option key={index} value={index === 0 ? '' : index}>{item}</Option>
                ))
              }
            </Select>
          </li>
          <li className="items">
            <label className="label-text">商户编号:</label>
            <Input value={this.state.merchantCode} onChange={this.bindValue.bind(this, 'merchantCode')} placeholder="请输入商户编号" />
          </li>
          {
            this.state.isactive !== 2 ? (
            <li className="items">
              <label className="label-text">激活码类型:</label>
              <Select 
                placeholder="选择激活码类型" 
                value={this.state.activationCodeType} 
                onChange={this.bindValue.bind(this, 'activationCodeType')} 
                style={{width: '210px'}}
                key={`activationCodeType-${this.state.isactive}`}
              >
                {
                  this.state.activationCodeTypeData.map((item, index) => (
                    <Option key={index} value={item.value}>{item.label}</Option>
                  ))
                }
              </Select>
            </li>
          ) : null}
          <li className="items">
            <Button type="primary" onClick={this.searchEvent.bind(this)}>查询</Button>
            <Button onClick={this.resetFilter} style={{ marginLeft: 8 }}>重置</Button>
          </li>
        </ul>
        {/* 表格 */}
        <Table
          columns={columns}
          dataSource={this.state.facilityData}
          className="table-box"
          rowKey={record => record.id}
          loading={this.state.isLoading}
          pagination={this.state.search}
          scroll={{x: 1450}}
        />
      </div>
    );
  }
}
export default FacilityList;



// WEBPACK FOOTER //
// ./src/containers/backEnd/facilityMangement/facilitylist.jsx